import "./Feedback.scss";
import { Rating } from "./Rating.tsx";

import { Questions } from "./Questions.tsx";
import { useEffect, useState } from "react";
import { CardComponent } from "../card";
import "../../../styles/typography.scss";
import { Answer, FeedBackProps, Question, SendAnswer } from "@anoki/fse-common";

export function Feedback({
  question,
  rating,
  questions,
  onSend,
  buttons,
  maxCharactersMessage,
  successMessage,
  errorMessage,
  loadingMessage,
  isLoading = false,
  hasError = false,
  openAnswerPlaceholder,
}: FeedBackProps) {
  const [ratingValue, setRatingValue] = useState(() => rating ?? 0);
  const [selectedAnswers, setSelectedAnswers] = useState<Array<SendAnswer>>([]);
  const [openAnswer, setOpenAnswer] = useState<string>("");
  const [hide, setHide] = useState<boolean>(false);
  const [filteredQuestions, setFilteredQuestions] = useState<Question[]>([]);

  useEffect(() => {
    const validQuestions = () => {
      const currentQuestions = [];
      if (ratingValue >= 3) {
        currentQuestions[0] = questions[0];
        currentQuestions[1] = questions[2];
      } else {
        currentQuestions[0] = questions[1];
        currentQuestions[1] = questions[2];
      }

      return currentQuestions;
    };

    setFilteredQuestions(validQuestions());
    setSelectedAnswers([]);
  }, [ratingValue, questions]);

  const onStarClick = (value: number) => {
    setRatingValue(value);
  };

  /* 
   * PREVIOUS CHECKBOX IMPLEMENTATION:
   * More complex implementation for checkboxes where multiple selections are allowed
   * It used the lodash 'xor' function which performs "exclusive or" operation - meaning it toggles items
   *
   */
  /* const onChangeAnswer = (questionId: string, answer: Answer) => {
    const currentAnswer = selectedAnswers.find(
      (value) => value.id === questionId,
    );

    if (!currentAnswer) {
      setSelectedAnswers((prev) => [
        ...prev,
        {
          id: questionId,
          answer: [answer],
        },
      ]);
      return;
    }

    const index = findIndex(currentAnswer.answer, { id: answer.id });
    if (index === -1) {
      currentAnswer.answer = [...currentAnswer.answer, answer];
    } else {
      currentAnswer.answer = xor([...currentAnswer.answer], [answer]);
    }
    setSelectedAnswers((prev) => xor([...prev, currentAnswer]));
  }; */

  const onChangeAnswer = (questionId: string, answer: Answer) => {
    // For radio buttons, we simply replace the answer
    setSelectedAnswers((prev) => {
      const otherAnswers = prev.filter((a) => a.id !== questionId);
      return [...otherAnswers, {
        id: questionId,
        answer: [answer], // Single answer for radio buttons
      }];
    });
  };

  const handleOpenAnswer = (answer: string) => {
    setOpenAnswer(answer);
  };
  const onConfirm = () => {
    setHide(true);

    const formatSelectedAnswers = selectedAnswers
      .map((answer) => answer.answer.map((a) => a.answer))
      .flat();

    const answer = {
      rating: ratingValue,
      closedAnswer: formatSelectedAnswers,
      openAnswer: openAnswer,
    };

    onSend(answer);
  };

  const handleMessage = () => {
    if (isLoading) {
      return loadingMessage;
    }

    if (hasError) {
      return errorMessage;
    }

    return successMessage;
  };

  const resetFeedback = () => {
    setRatingValue(0);
  }

  return (
    <CardComponent.Root>
      {!hide && (
        <>
          <div className="p-3 d-flex flex-column gap-3 align-items-start">
            <p className="fs-5 fw-semibold">{question}</p>
            <Rating onClick={onStarClick} rating={ratingValue} />
          </div>
          {ratingValue > 0 && (
            <div className="feedback-questions-container">
              <Questions
                onSend={onConfirm}
                questions={filteredQuestions}
                onChangeAnswer={onChangeAnswer}
                values={selectedAnswers}
                openAnswer={openAnswer}
                handleOpenAnswer={handleOpenAnswer}
                resetFeedback={resetFeedback}
                buttons={buttons}
                maxCharactersMessage={maxCharactersMessage}
                openAnswerPlaceholder={openAnswerPlaceholder}
              />
            </div>
          )}
        </>
      )}
      {hide && (
        <div className="steppers-content p-4" aria-live="polite">
          <p className={"feedback-final-message fw-semibold fs-custom"}>{handleMessage()}</p>
        </div>
      )}
    </CardComponent.Root>
  );
}
